/**
 * @file
 * Homepage Video Carousel using Splide.js
 *
 * Requirements:
 * - Display up to 6 videos
 * - Manual navigation only (no auto-advance)
 * - First video autoplays
 * - Left/right scroll functionality
 * - Content manager can set order
 * - Works on desktop and mobile
 */

(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.homepageVideoCarousel = {
    attach: function (context, settings) {
      // Find all homepage video carousel instances
      $('.homepage-video-carousel', context).once('homepage-video-carousel').each(function() {
        var carouselElement = this;
        // Check if Splide is available
        if (typeof Splide === 'undefined') {
          console.error('Splide library is not loaded');
          return;
        }

        // Initialize Splide carousel
        const splide = new Splide(carouselElement, {
          // Basic settings
          type: 'loop',           // Enable infinite loop
          perPage: 1,             // Show one video at a time
          perMove: 1,             // Move one slide at a time
          gap: 0,                 // No gap between slides

          // Navigation
          arrows: true,           // Show prev/next arrows
          pagination: true,       // Show pagination dots
          keyboard: true,         // Enable keyboard navigation (accessibility)
          drag: true,             // Enable mouse drag

          // Autoplay disabled per requirements
          autoplay: false,        // Manual navigation only

          // Performance
          lazyLoad: 'nearby',     // Lazy load nearby slides for performance
          preloadPages: 1,        // Preload 1 page ahead

          // Accessibility
          ariaLabel: 'Homepage Video Carousel',
          ariaLabelledby: 'homepage-video-carousel-label',

          // Video-specific settings
          video: {
            autoplay: true,       // Autoplay first video only
            mute: false,          // Videos not muted
            hideControls: false,  // Show video controls
            loop: false,          // Videos don't loop

            // Player options for embedded videos (YouTube, Vimeo)
            playerOptions: {
              youtube: {
                rel: 0,                // Don't show related videos
                modestbranding: 1,     // Minimal YouTube branding
                controls: 1,           // Show controls
                fs: 1,                 // Allow fullscreen
                cc_load_policy: 0,     // Don't show captions by default
                iv_load_policy: 3,     // Don't show annotations
                playsinline: 1         // Play inline on mobile
              },
              vimeo: {
                byline: false,         // Hide author name
                portrait: false,       // Hide author portrait
                title: false,          // Hide video title
                controls: true,        // Show controls
                dnt: true             // Do not track
              },
              htmlVideo: {
                controls: true,        // Show controls for HTML5 video
                playsInline: true      // Play inline on mobile
              }
            }
          },

          // Responsive breakpoints
          breakpoints: {
            // Mobile devices (< 768px)
            767: {
              arrows: false,        // Hide arrows on mobile (use swipe)
              pagination: true,     // Keep dots visible
              drag: true,           // Enable swipe
              wheel: false,         // Disable mouse wheel
              flickPower: 300,      // Swipe sensitivity
              flickMaxPages: 1      // Limit swipe distance
            },
            // Tablets (768px - 991px)
            991: {
              arrows: true,         // Show arrows
              pagination: true,     // Show dots
              gap: 0                // No gap
            },
            // Desktop (>= 992px)
            9999: {
              arrows: true,         // Show arrows
              pagination: true,     // Show dots
              gap: 0                // No gap
            }
          },

          // Classes for styling
          classes: {
            arrows: 'splide__arrows homepage-carousel__arrows',
            arrow : 'splide__arrow homepage-carousel__arrow',
            prev  : 'splide__arrow--prev homepage-carousel__arrow--prev',
            next  : 'splide__arrow--next homepage-carousel__arrow--next',
            pagination: 'splide__pagination homepage-carousel__pagination',
            page: 'splide__pagination__page homepage-carousel__page'
          }
        });

        // Event: Before the carousel moves to a different slide
        splide.on('move', function(newIndex, oldIndex) {
          // Pause video on the old slide
          const oldSlide = splide.Components.Slides.getAt(oldIndex);
          if (oldSlide) {
            const oldVideo = oldSlide.slide.querySelector('video, iframe');
            if (oldVideo) {
              if (oldVideo.tagName === 'VIDEO') {
                oldVideo.pause();
              } else if (oldVideo.tagName === 'IFRAME') {
                // Pause YouTube/Vimeo videos via postMessage
                const src = oldVideo.src;
                if (src.includes('youtube.com') || src.includes('youtu.be')) {
                  oldVideo.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                } else if (src.includes('vimeo.com')) {
                  oldVideo.contentWindow.postMessage('{"method":"pause"}', '*');
                }
              }
            }
          }
        });

        // Event: After the carousel has moved to a different slide
        splide.on('moved', function(newIndex) {
          // Auto-play video on the new slide when it becomes visible
          const newSlide = splide.Components.Slides.getAt(newIndex);
          if (newSlide) {
            const newVideo = newSlide.slide.querySelector('video, iframe');
            if (newVideo) {
              if (newVideo.tagName === 'VIDEO') {
                newVideo.play().catch(function(error) {
                  console.log('Video autoplay prevented:', error);
                });
              } else if (newVideo.tagName === 'IFRAME') {
                // Play YouTube/Vimeo videos via postMessage
                const src = newVideo.src;
                if (src.includes('youtube.com') || src.includes('youtu.be')) {
                  newVideo.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                } else if (src.includes('vimeo.com')) {
                  newVideo.contentWindow.postMessage('{"method":"play"}', '*');
                }
              }
            }
          }
        });

        // Mount the carousel
        // Check if Video extension is available
        if (window.splide && window.splide.Extensions && window.splide.Extensions.Video) {
          splide.mount(window.splide.Extensions);
        } else {
          // Mount without video extension if not available
          splide.mount();
        }

        // Ensure first video autoplays on page load
        splide.on('mounted', function() {
          // Look for the first video wrapper with data-autoplay attribute
          const firstVideoWrapper = carouselElement.querySelector('[data-autoplay="true"]');
          if (firstVideoWrapper) {
            const firstVideo = firstVideoWrapper.querySelector('video');
            if (firstVideo) {
              // Set autoplay and muted attributes for HTML5 video
              firstVideo.setAttribute('autoplay', '');
              firstVideo.setAttribute('muted', '');
              firstVideo.setAttribute('loop', '');
              firstVideo.setAttribute('playsinline', '');
              firstVideo.muted = true; // Ensure muted property is set
              firstVideo.loop = true;
              firstVideo.playsInline = true;

              // Try to play the video
              const playPromise = firstVideo.play();
              if (playPromise !== undefined) {
                playPromise.then(function() {
                  console.log('First video autoplay successful');
                }).catch(function(error) {
                  console.log('First video autoplay prevented:', error);
                  // If autoplay is blocked, at least ensure video is ready
                  firstVideo.load();
                });
              }
            }
          }
        });

        // Store splide instance on the element for potential external access
        carouselElement.splide = splide;
      });
    }
  };

})(Drupal, jQuery);
